import { config } from 'data';
import { statisticsService } from 'services';
import { useQuery } from 'hooks';
import { StatisticsPaymentsParams } from 'types/services';

const useStatisticsPaymentsQuery = (params: StatisticsPaymentsParams) => useQuery({
  queryKey: [config.STATISTICS_PAYMENTS_QUERY_KEY, params],
  queryFn: () => statisticsService.getPayments(params),
});

export default useStatisticsPaymentsQuery;
